// client/src/components/auth/InterestExpression.js
import useInterestExpression from '../../hooks/useInterestExpression'
import './Auth.css'

/**
 * InterestExpression component - allows users without an access code
 * to express interest by submitting their email address
 *
 * Designed to be subtle and non-intrusive on the signup page
 */
function InterestExpression() {
  const {
    showForm,
    email,
    submitting,
    submitted,
    emailRef,
    toggleForm,
    handleEmailChange,
    handleSubmit,
  } = useInterestExpression()

  return (
    <div className="interest-expression-container">
      {!showForm && !submitted && (
        <button
          type="button"
          className="interest-expression-trigger"
          onClick={toggleForm}
          aria-expanded="false"
          aria-controls="interest-expression-form"
          aria-label="Express interest in joining without an access code"
        >
          Don't have an access code?{' '}
          <span className="interest-expression-cta">
            Let us know you're interested!
          </span>
        </button>
      )}

      {showForm && !submitted && (
        <div
          id="interest-expression-form"
          className="interest-expression-form"
          aria-label="Interest expression form"
        >
          <div className="interest-expression-header">
            <p className="interest-expression-description">
              Enter your email and we'll notify you when access codes become
              available.
            </p>
            <button
              type="button"
              className="interest-expression-close"
              onClick={toggleForm}
              aria-label="Close interest form"
              disabled={submitting}
            >
              ✕
            </button>
          </div>

          <div className="interest-expression-input-group">
            <input
              ref={emailRef}
              type="email"
              value={email}
              onChange={handleEmailChange}
              className="interest-expression-input"
              placeholder="your.email@example.com"
              disabled={submitting}
              required
              aria-label="Email address"
              autoFocus
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault()
                  handleSubmit(e)
                }
              }}
            />
            <button
              type="button"
              className="interest-expression-submit"
              onClick={handleSubmit}
              disabled={submitting || !email}
              aria-label="Submit interest"
            >
              {submitting ? 'Submitting...' : 'Notify Me'}
            </button>
          </div>
        </div>
      )}

      {submitted && (
        <div
          className="interest-expression-success"
          role="status"
          aria-live="polite"
          aria-atomic="true"
        >
          ✓ Thanks! We'll be in touch soon.
        </div>
      )}
    </div>
  )
}

export default InterestExpression
